export default "__VITE_ASSET__D6AKLL$f__"